import { playerEventsStorage } from '../../storages';

export function clearSeamlessPrefetchEventWithDelay() {
  setTimeout(() => {
    playerEventsStorage.clearIsSeamlessPrefetchEventFired();
  }, 1000);
}
